export default "__VITE_ASSET__b5f53180__"